const TeamData = [
  {
    link: 'https://github.com/ninox14',
    name: 'ninox14',
  },
  {
    link: 'https://github.com/roninpepe',
    name: 'roninpepe',
  },
  {
    link: 'https://github.com/wunlei',
    name: 'wunlei',
  },
];

export default TeamData;
